import onDocumentReady from 'shared/onDocumentReady';
import router from './router';
import SpaRoot from './SpaRoot.vue';
import { createApp, registerAppPlugin } from '~/vue/createApp';
import { markSpaMounted } from './mounted';
import { setRouter } from './navigate';

// so that the popups mounted on their own app - see simplePopupFactory - resolve
// `$router` and `$route` the same way a routed page does
registerAppPlugin(router);
// and so that navigateTo can reach it without importing the route table
setRouter(router);

/**
 * Mounts the app on the placeholder every routed page inherits from
 * templates/spa_page.html. A django page that is not part of the SPA renders no
 * such element and is left alone.
 */
function mountSpa () {
    const el = document.getElementById('spa-root');
    if (!el) {
        return;
    }
    // before the mount, not after: the page's components render *during* it, and the link
    // components ask whether the router can take a link while they are rendering - into a
    // computed, which would cache the answer from before the flag was set
    markSpaMounted();
    createApp(SpaRoot).mount(el);
}

onDocumentReady(mountSpa);
